// extracted by mini-css-extract-plugin
export default {"dialog-content":"TCoV1vsb9br1VN6eYVGd"};